<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ijbrkN/tc-custom/9781526766311.jpg?1729185276395" alt="This image is the cover for the book Sovereign of the Seas, 1637"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sovereign of the Seas, 1637
      </h1>
      <p class="bookDescription body article font2">
        <b>“McKay’s artful renderings provide a fitting tribute to this amazing vessel and those who participated in her planning and construction.” —<i>Pirates and Privateers</i></b><br/><br/><i>Sovereign of the Seas</i> was the most spectacular, extravagant and controversial warship of the early seventeenth century. The ultimate royal prestige project, whose armament was increased by the King’s decree to the unheard-of figure of 100 guns, the ship finally cost the equivalent of ten more conventional warships. A significant proportion of this total was spent on her gilded decoration, which gave the ship a unique combination of firepower and visual impact in battle that led her Dutch opponents to dub her the “Golden Devil.” <br/><br/>It is unsurprising that such a high-profile ship should be well-documented, but there are no contemporary plans and much of the visual evidence is contradictory. In this book, John McKay sets out to analyze the data and reconstruct the design and appearance of the ship in a degree of detail never previously attempted. The results are presented as a folio of superbly drafted plans, isometric drawings and colored renderings, covering every aspect of the design from the hull form to the minutiae of sails and rigging. Each section is accompanied by an explanatory text, setting out the rationale for his conclusions, so the book will be of value to historians of the period as well as providing superb reference for any modeler tackling of one of the most popular of all sailing ship subjects.<br/><br/><b>“A magnificent book on a magnificent ship.” —<i>Nautical Research Journal</i></b><br/><br/><b>“Very few books of warships contain the level of detail provided here.” —<i>Firetrench</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John McKay
      </h2>
      
      <p class="authorDescription body article">John McKay came from a family that had worked in the Scottish shale oil industry from the 1870s to the early 1900s. He worked as a Senior Executive Officer for HM Customs and Excise for over 30 years. He was a member of the City of Edinburgh District Council 1974 - 77 and 1978 - 88, and was Lord Provost 1984 - 88. He was awarded a PhD from the Open University in 1985 for his work on the social history of the Scottish shale oil industry. From 1994 to 2000 he worked as a part-time tutor for the Open University and the University of Dundee. He died in 2011.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Seaforth Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?649f1769